/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    OKEFENOKEE_AVAILABILITY_DATE_RANGE_STARTED,
    OKEFENOKEE_AVAILABILITY_DATE_RANGE_SUCCESS,
    OKEFENOKEE_AVAILABILITY_DATE_RANGE_FAIL,
} from '../constants';

const STATUSENUM = Object.freeze({
    init: 'Okefenokee availability call initiated',
    success: 'Okefenokee availability call succeeded',
    fail: 'Okefenokee availability call failed: ',
});

const INITIALSTATE = { status: '', results: {} };

export default function okefenokee(state = INITIALSTATE, action) {
    const newState = { ...state };
    switch (action.type) {
        case OKEFENOKEE_AVAILABILITY_DATE_RANGE_STARTED:
            newState.status = STATUSENUM.init;
            return newState;

        case OKEFENOKEE_AVAILABILITY_DATE_RANGE_SUCCESS:
            newState.results = action.payload;
            newState.status = STATUSENUM.success;
            return newState;

        case OKEFENOKEE_AVAILABILITY_DATE_RANGE_FAIL:
            newState.status = STATUSENUM.fail + action.payload;
            return newState;

        default:
            return newState;
    }
}
